import DetailPage, { Services } from "../common/detail";
import { ServicesContainer } from "../common/serviceContainer";
import { routePath } from "../constants/routePath";
import ItemCategories from "../features/ItemsCategories/itemCategories";
import OTP from "../features/Otp/otp";
import OTPAppoint from "../features/OtpAppoinment/OtpAppoinment";
import SetMpin from "../features/SetMpin/setMpin";
import AdvancePayment from "../features/advancePayment/advancePayment";
import { Advertice } from "../features/advertisement/advertisement";
import Appoinment from "../features/appoinment/appoinment";
import AppoinmentDashboard from "../features/appoinmentDashboard/appoinmentDashboard";
import AssociatedUsers from "../features/associatedUsers/associatedUsers";
import BulkMessage from "../features/bulkMessages/bulkMessages";
import { CustomerInformation } from "../features/counterInformation/counterInformation";
import CounterSell from "../features/counterSell/counterSell";
import CounterSellBilling from "../features/counterSellBilling/counterSellBilling";
import { ContainerCont } from "../features/countersellContainer/container";
import DashboardT from "../features/dashboard";
import Dashboard from "../features/dashboard/dashboard";
import EmployeeInfo from "../features/employeeInfo/employeeInfoCM";
import EmployeePayRoll from "../features/employeePayRoll/employeePayRol";
import Salary from "../features/employeePayRoll/salary";
import Expense from "../features/expense/expense";
import FavRate from "../features/fav/favRate";
import HelpAndSupport from "../features/helpAndSupport/helpAndSupport";
import { Inventory } from "../features/inventary/inventory";
import { ItemService } from "../features/itemSerivce/itemService";
import ItemServices from "../features/items_services/ItemServices";
import KycProcess from "../features/kycProcess/kycProcess";
import CounterToken from "../features/landingPage/counterToken";
import Franchise from "../features/landingPage/franchise";
import LandingPage from "../features/landingPage/landingPage";
import MonthlyBill from "../features/landingPage/monthlyBill";
import { RestaurantPage } from "../features/landingPage/restaurantPage";
import Login from "../features/login/login";
import MobileMenuPage from "../features/mobileMenu/mobileMenuPage";
import MyBusiness from "../features/myBusiness/myBussiness";
import MyProfile from "../features/myProfile/myProfile";
import { AddOffers } from "../features/offers/addOffers";
import { GetAllOfferByBiller } from "../features/offers/getAllOfferByBiller";
import OTPForget from "../features/otpForget/otpForgetpin";
import OutstandingReport from "../features/outStandingReport/outStandingReport";
import PaymentStruct from "../features/payment/payment";
import PaymentReceipt from "../features/paymentReceipt/paymentReceipt";
import { PrivacyPolicy } from "../features/privay_term/privacyPolicy";
import { TermService } from "../features/privay_term/termService";
import UserProfile from "../features/profile/profile";
import Purchase from "../features/purchase/purchase";
import { PurchaseMagnemt } from "../features/purchaseManagment/purchaseManagment";
import UserRegistration from "../features/registration/registration";
import CashCounterSale from "../features/reports/cashCounterSale/cashCounterSale";
import DiscountinuedItem from "../features/reports/discountedItems/discountedItems";
import EmployeePaymentRole from "../features/reports/employeePaymentReport/employeePaymentRole";
import GstReportText from "../features/reports/gstReport/index.jsx";
import SalesReport from "../features/reports/itemCategory";
import ItemWiseCategoryCounter from "../features/reports/itemWiseSaleSummary.jsx";
import RateChangeItemHistory from "../features/reports/rateChangeHistory/rateChangeHistory";
import Reports from "../features/reports/reports";
import TotalCounterSellReport from "../features/reports/totalCounterSaleReport.jsx/totalCounterSellReport";
import ResetMpin from "../features/resetPin/resetPin";
import { ReviewAndRating } from "../features/reviewRating/reviewAndRating";
import ServicesList from "../features/services/servicesList";
import Setting from "../features/setting/setting";
import { ShareEmployeeProfile } from "../features/shareEmployeeProfile/shareEmployeeProfile";
import ShareMessage from "../features/shareMessage/shareMessage";
import { ShareMessageContainer } from "../features/shareMessageContainer/shareMessageContainer";
import { ShareRateCard } from "../features/shareRateCard/shareRateCard";
import SmbAccountReacharge from "../features/smbAccoundReacharge/smbAccoundReacharge";
import Stocks from "../features/stocks/stocks";
import TableMaster from "../features/tableMaster/tableMaster";
import TableSection from "../features/tableSection/tableSection";
import Billing from "../features/updateBills/Billing";
import OldUpdateBills from "../features/updateBills/oldupdateBills";
import ExcelUpload from "../features/upload/uploadbill";
import UserLogin from "../features/userLogin/userLogin";
import RawMaterialReportT from "../features/reports/RawMaterialReport/index.jsx";
import ListOfItemSerivces from "../features/reports/ListOfItemSerivces/ListOfItemSerivces.jsx";
import CounterSaleOfSelectedItem from "../features/reports/counterSaleOfSelectedItem/counterSaleOfSelectedItem.jsx";
import InventoryT from "../features/stocks/index.jsx";
import PurchaseReportT from "../features/reports/purchaseReport/index.jsx";
import ExpenceReport from "../features/reports/expensereport/expensereport.jsx";
import EmployeeAdvanceReport from "../features/reports/employeeAdvanceReport/employeeAdvanceReport.jsx";
import { CustomerDetailReport } from "../features/reports/customerDetailReport/index.js";
import CustomerInfo from "../features/counterInformation/CustomerInfo.jsx";
import AppoinmentReport from "../features/reports/appoinmentReport/appoimentReportapge.jsx";
import OldBilling from "../features/updateBills/oldBilling.jsx";
import UpdateBills from "../features/updateBills/updateBills.jsx";
import WhatIsElegant from "../features/landingPage/whatIsElegant.jsx";
import AssistantLogin from "../features/userLogin/assistantLogin.js";
import EmploDeReport from "../features/reports/employeeDetailReport/employeeDetailReport.jsx";
import { Salon, SalonPage } from "../features/landingPage/salon.jsx";
import { Details } from "../features/services/details.jsx";
import ProfilePage from "../features/landingPage/profile.jsx";
import CompanyUseLogin from "../features/companyLogin/companyLogin.jsx";
// import AddvertisementTools from "../features/companyLogin/advertisementTools.jsx";
import RechargeTools from "../features/companyLogin/rechargeTools.jsx";
import SupportTools from "../features/companyLogin/supportTools.jsx";
import AddvertisementTools from "../features/companyLogin/advertisementTools.jsx";
import EmployeeAttendace from "../features/employeeInfo/empAttendace.jsx";
import { Offers } from "../features/companyLogin/offers.jsx";
import { Advertisement } from "../features/companyLogin/advertisements.jsx";
import RechargeForm from "../features/companyLogin/recharge.jsx";
import UserProfileC from "../features/companyLogin/userprofile.jsx";
import RechargeReport from "../features/companyLogin/rechargeReport.jsx";
import ReportsTab from "../features/companyLogin/reportsTab.jsx";
import InstituteInformation from "../features/myInstitute/instituteInformation.js";
import { MyInstitute } from "../features/myInstitute/MyInstitute.js";
import Enquiries from "../features/myInstitute/enquiries.js";
import { JobHiringPost } from "../features/Jobhiringpost/jobHiringPost.js";
import Jobs from "../features/Jobs/jobs.jsx";
import ApplyJob from "../features/Jobs/ApplyJob.jsx";
import MyJobProfile from "../features/Jobs/MyjobProfile.jsx";
import EditProfile from "../features/Jobs/EditProfile.jsx";
import JobFilter from "../features/Jobs/JobFilter.jsx";
import CourseList from "../features/institute/courseList.jsx";
import CourseDetails from "../features/institute/courseDetail.jsx";
import { InstituteInfo } from "../features/institute/instituteInfo.jsx";
import { MyFranchise } from "../features/MyFranchise/MyFranchise.js";
import FranchiseList from "../features/franchise/franchises.js";
import FranchiseDetails from "../features/franchise/franchiseDetails.jsx";
import CustomerLogin from "../features/userLogin/login.js";
import { WhiteLables } from "../features/WhiteLabels/WhiteLabels.js";
import LabelsList from "../features/whitelabel/whiteLabels.js";
// import CourseDetails from "../features/institute/courseDetails.jsx";
const menuLoginHeader = [
  {
    title: "Home",
  },
  {
    title: "About",
  },
];
export const RoutesSet = [
  {
    routePath: routePath.ROOT,
    component: <LandingPage />,
  },
  {
    routePath: routePath.WHATISELEGANTPRIME,
    component: <WhatIsElegant />,
  },
  {
    routePath: routePath.LANDINGPAGERESTORENT,
    component: <RestaurantPage />,
  },
  {
    routePath: routePath.OTPFORGET,
    component: <OTPForget />,
  },
  {
    routePath: routePath.LANDINGPAGECOUNTERTOKEN,
    component: <CounterToken />,
  },
  {
    routePath: routePath.DETAIL,
    component: <DetailPage />,
  },
  {
    routePath: routePath.ADVERTICE,
    component: <Advertice />,
  },
  {
    routePath: routePath.FAV,
    component: <FavRate />,
  },
  {
    routePath: routePath.REGISTRATION,
    component: <UserRegistration />,
  },
  {
    routePath: routePath.OTP,
    component: <OTP />,
  },
  {
    routePath: routePath.OTPAPPOINMENT,
    component: <OTPAppoint />,
  },
  {
    routePath: routePath.APPOINMENTDASHBOARD,
    component: <AppoinmentDashboard />,
  },
  {
    routePath: routePath.APPOINMENT,
    component: <Appoinment />,
  },
  {
    routePath: routePath.USERPROFILE,
    component: <UserProfile />,
  },
  {
    routePath: routePath.INVENTORY,
    component: <Inventory />,
  },
  {
    routePath: routePath.SETMPIN,
    component: <SetMpin />,
  },
  {
    routePath: routePath.LANDINGPAGEMONTHLYBILL,
    component: <MonthlyBill />,
  },
  {
    routePath: routePath.SERVICESLIST,
    component: <ServicesList />,
  },
  {
    routePath: routePath.JOBSLIST,
    component: <JobFilter />,
  },
  {
    routePath: routePath.JOBS,
    component: <Jobs />,
  },
  {
    routePath: routePath.MYJOBPROFILE,
    component: <MyJobProfile />,
  },
  {
    routePath: routePath.EDITPROFILE,
    component: <EditProfile />,
  },
  {
    routePath: routePath.APPLYJOB,
    component: <ApplyJob />,
  },
  {
    routePath: routePath.LANDINGPAGEFRANCHISE,
    component: <Franchise />,
  },
  {
    routePath: routePath.CUSTOMERINFORMATION,
    component: <CustomerInformation />,
  },
  {
    routePath: routePath.REVIEWANDRATING,
    component: <ReviewAndRating />,
  },
  {
    routePath: routePath.LOGIN,
    component: <UserLogin />,
  },
  {
    routePath: routePath.DASHBOARD,
    component: <DashboardT />,
  },
  {
    routePath: routePath.COUNTERSELL,
    component: <ContainerCont />,
  },
  {
    routePath: routePath.OLDCOUNTERSELL,
    component: <OldBilling />,
  },
  {
    routePath: routePath.COUNTERSELLBILLING,
    component: <Billing />,
  },
  {
    routePath: routePath.OLDUPDATEBILLS,
    component: <OldUpdateBills />,
  },
  {
    routePath: routePath.UPDATEBILLS,
    component: <UpdateBills />,
  },
  {
    routePath: routePath.MYPROFILE,
    component: <MyProfile />,
  },
  {
    routePath: routePath.SHAREMESSAGEPROFILE,
    component: <ShareEmployeeProfile />,
  },
  {
    routePath: routePath.EMPLOYEEINFO,
    component: <EmployeeInfo />,
  },
  {
    routePath: routePath.MYBUSSINESS,
    component: <MyBusiness />,
  },
  {
    routePath: routePath.SHAREMESSAGECONTAINER,
    component: <ShareMessageContainer />,
  },
  {
    routePath: routePath.TABLEMASTER,
    component: <TableMaster />,
  },
  {
    routePath: routePath.SHARERATECARD,
    component: <ShareRateCard />,
  },
  {
    routePath: routePath.SHARESESSAGE,
    component: <ShareMessage />,
  },
  {
    routePath: routePath.ITEMSERVICES,
    component: <ItemService />,
  },
  {
    routePath: routePath.ADVANCEPAYMENT,
    component: <AdvancePayment />,
  },
  {
    routePath: routePath.TABLESECTION,
    component: <TableSection />,
  },
  {
    routePath: routePath.EMPLOYEEPAYROLL,
    component: <EmployeePayRoll />,
  },
  {
    routePath: routePath.EMPLOYEEDETAILREPORT,
    component: <EmploDeReport />,
  },
  {
    routePath: routePath.ITEMCATEGORIES,
    component: <ItemCategories />,
  },
  { routePath: routePath.ASSOCIATEDUSERS, component: <AssociatedUsers /> },
  {
    routePath: routePath.PAYMENTRECEIPT,
    component: <PaymentReceipt />,
  },
  {
    routePath: routePath.OUTSTANDINGREPORT,
    component: <OutstandingReport />,
  },
  {
    routePath: routePath.MOBILEPAGEMENU,
    component: <MobileMenuPage menuLoginHeader={menuLoginHeader} />,
  },
  {
    routePath: routePath.SMBACCOUNTREACHARGE,
    component: <SmbAccountReacharge />,
  },
  {
    routePath: routePath.REPORTS,
    component: <Reports />,
  },
  {
    routePath: routePath.STOCKS,
    component: <Stocks />,
  },
  {
    routePath: routePath.PURCHASE,
    component: <Purchase />,
  },
  {
    routePath: routePath.EXPENCE,
    component: <Expense />,
  },
  {
    routePath: routePath.HELPSUPPORT,
    component: <HelpAndSupport />,
  },

  {
    routePath: routePath.EMPLOYEEATTENDANCE,
    component: <EmployeeAttendace />,
  },
  {
    routePath: routePath.PURCHASEMANAGMENT,
    component: <PurchaseMagnemt />,
  },
  {
    routePath: routePath.JOBHIRINGPOST,
    component: <JobHiringPost />,
  },
  {
    routePath: routePath.RESETMPIN,
    component: <ResetMpin />,
  },
  {
    routePath: routePath.SETTING,
    component: <Setting />,
  },
  {
    routePath: routePath.RATECHANGE,
    component: <RateChangeItemHistory />,
  },
  {
    routePath: routePath.CASHCOUNTERSALE,
    component: <CashCounterSale />,
  },
  {
    routePath: routePath.KYCPROCESS,
    component: <KycProcess />,
  },
  {
    routePath: routePath.PRIVACYPOLICY,
    component: <PrivacyPolicy />,
  },

  {
    routePath: routePath.SERVICES,
    component: <ServicesContainer />,
  },
  {
    routePath: routePath.TERMSOFSERVICE,
    component: <TermService />,
  },
  {
    routePath: routePath.ADDOFFER,
    component: <AddOffers />,
  },
  {
    routePath: routePath.ADVERTISEMENT,
    component: <Advertisement />,
  },
  {
    routePath: routePath.RECHARGE,
    component: <RechargeForm />,
  },
  {
    routePath: routePath.RECHARGEREPORT,
    component: <RechargeReport />,
  },
  {
    routePath: routePath.REPORTSTAB,
    component: <ReportsTab />,
  },
  {
    routePath: routePath.OFFERS,
    component: <Offers />,
  },
  {
    routePath: routePath.USERPROFILEC,
    component: <UserProfileC />,
  },
  {
    routePath: routePath.GETOFFERBYBILLER,
    component: <GetAllOfferByBiller />,
  },
  {
    routePath: routePath.PAYMENTSTRUCT,
    component: <PaymentStruct />,
  },
  {
    routePath: routePath.BULTMESSAGE,
    component: <BulkMessage />,
  },
  {
    routePath: routePath.BLUESERIVE,
    component: <ExcelUpload />,
  },
  {
    routePath: routePath.SALARY,
    component: <Salary />,
  },
  {
    routePath: routePath.TOTALCOUNTERSELLREPORT,
    component: <TotalCounterSellReport />,
  },
  {
    routePath: routePath.Enquiries,
    component: <Enquiries />,
  },
  {
    routePath: routePath.GSTREPORT,
    component: <GstReportText />,
  },
  {
    routePath: routePath.ITEMWISESALE,
    component: <DiscountinuedItem />,
  },
  {
    routePath: routePath.ITEMCATEGORY,
    component: <SalesReport />,
  },
  {
    routePath: routePath.USERLOGIN,
    component: <Login />,
  },
  {
    routePath: routePath.RAWMATERIALREPORTS,
    component: <RawMaterialReportT />,
  },
  {
    routePath: routePath.LISTOFITEMSSERVICES,
    component: <ListOfItemSerivces />,
  },
  {
    routePath: routePath.COUNTERSALEOFSELECTEDITEMS,
    component: <CounterSaleOfSelectedItem />,
  },
  {
    routePath: routePath.INVENTORYREPORTS,
    component: <InventoryT />,
  },
  {
    routePath: routePath.PURCHASEREPORTS,
    component: <PurchaseReportT />,
  },
  {
    routePath: routePath.EXPENSEREPORTS,
    component: <ExpenceReport />,
  },
  {
    routePath: routePath.ITEMSWISECOUNTERSALEREPORT,
    component: <ItemWiseCategoryCounter />,
  },
  {
    routePath: routePath.EMPLOYEEADVANCEPAYMENTREPORT,
    component: <EmployeeAdvanceReport />,
  },
  {
    routePath: routePath.EMPLOYEEPAYROLLREPORT,
    component: <EmployeePaymentRole />,
  },
  {
    routePath: routePath.CUSTOMERINFOREPORT,
    component: <CustomerDetailReport />,
  },
  {
    routePath: routePath.CUSTOMERHISTORYREPORT,
    component: <CustomerInfo report={true} />,
  },
  {
    routePath: routePath.CUSTOMERAPPOINTMENTREPORT,
    component: <AppoinmentReport />,
  },
  {
    routePath: routePath.ASSISTANTLOGIN,
    component: <AssistantLogin />,
  },
  {
    routePath: routePath.SALON,
    component: <SalonPage />,
  },
  {
    routePath: routePath.DETAILS,
    component: <Details />,
  },
  {
    routePath: routePath.PROFILEPAGE,
    component: <ProfilePage />,
  },
  {
    routePath: routePath.COMPANYUSELOGIN,
    component: <CompanyUseLogin />,
  },
  {
    routePath: routePath.ADVERTISEMENTTOOLS,
    component: <AddvertisementTools />,
  },
  {
    routePath: routePath.RECHARGETOOLS,
    component: <RechargeTools />,
  },
  {
    routePath: routePath.SUPPORTTOOLS,
    component: <SupportTools />,
  },
  {
    routePath: routePath.MyInstitute,
    component: <MyInstitute />,
  },
  {
    routePath: routePath.COURSES,
    component: <CourseList />,
  },
  {
    routePath: routePath.COURSEDETAILS,
    component: <CourseDetails />,
  },
  {
    routePath: routePath.INSTITUTEINFO,
    component: <InstituteInfo />,
  },
  {
    routePath: routePath.MyFranchise,
    component: <MyFranchise />,
  },
  {
    routePath: routePath.FRANCHISE,
    component: <FranchiseList />,
  },
  {
    routePath: routePath.FRANCHISEDETAILS,
    component: <FranchiseDetails />,
  },
  {
    routePath: routePath.CUSTOMERLOGIN,
    component: <CustomerLogin />,
  },
  {
    routePath: routePath.WHITELABELS,
    component: <WhiteLables />,
  },
  {
    routePath: routePath.WHITELABLESLIST,
    component: <LabelsList />,
  },
];
